import { render, staticRenderFns } from "./distributionDetails.vue?vue&type=template&id=b2d8df20&scoped=true&"
import script from "./distributionDetails.vue?vue&type=script&lang=js&"
export * from "./distributionDetails.vue?vue&type=script&lang=js&"
import style0 from "./distributionDetails.vue?vue&type=style&index=0&id=b2d8df20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d8df20",
  null
  
)

export default component.exports